import { useFormContext, useWatch } from "react-hook-form";
import { useIntl } from "react-intl";

import Input from "components/v2/Input/Input";
import { cbmScopeOptions } from "pages/shipper/RequestForm/components/PackingList/PackingListDefaultOptions";
import PackingListRequiredHint from "@RequestFormV2/sections/PackingList/components/shared/PackingListRequiredHint";
import PackingListSelect from "@RequestFormV2/sections/PackingList/components/shared/PackingListSelect";
import { HANDLING_UNIT_COLUMN_WIDTHS } from "@RequestFormV2/sections/PackingList/components/shared/packingListColumnWidths";
import { getPackingListFieldPath } from "@RequestFormV2/sections/PackingList/utils/fieldPaths";
import type { CbmScope } from "@RequestFormV2/sections/PackingList/types";

type CbmInputFieldsProps = {
  index: number;
  showScopeRequiredHint: boolean;
  showValueRequiredHint: boolean;
  onChange: () => void;
};

export default function CbmInputFields({
  index,
  showScopeRequiredHint,
  showValueRequiredHint,
  onChange,
}: Readonly<CbmInputFieldsProps>) {
  const intl = useIntl();
  const { control } = useFormContext();
  const cbmScope = (useWatch({ name: getPackingListFieldPath(index, "cbm_scope"), control }) as CbmScope | null) ?? "piece";
  const cbmValueField = cbmScope === "total" ? "l_w_h_cbm_total" : "l_w_h_cbm_piece";
  const scopeOptions = cbmScopeOptions(intl);

  return (
    <>
      <div className="rfv2-packing-list-table__cbm-value" style={{ width: HANDLING_UNIT_COLUMN_WIDTHS.cbmValue }}>
        <Input
          name={getPackingListFieldPath(index, cbmValueField)}
          type="number"
          placeholder={intl.formatMessage({
            id: "new-request.packing-list.cubicMeters",
            defaultMessage: "Cubic Meters (CBM)",
          })}
          hideError={showValueRequiredHint}
          onChange={onChange}
        />
        {showValueRequiredHint && <PackingListRequiredHint />}
      </div>
      <div className="rfv2-packing-list-table__cbm-scope" style={{ width: HANDLING_UNIT_COLUMN_WIDTHS.cbmScope }}>
        <PackingListSelect
          name={getPackingListFieldPath(index, "cbm_scope")}
          hideError={showScopeRequiredHint}
          options={scopeOptions}
          placeholder={intl.formatMessage({
            id: "new-request.packing-list.cubicScope",
            defaultMessage: "CBM Scope",
          })}
          onChange={onChange}
        />
        {showScopeRequiredHint && <PackingListRequiredHint />}
      </div>
    </>
  );
}
